import { Component, OnInit, ViewEncapsulation, computed, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { toSignal } from '@angular/core/rxjs-interop';

import { environment } from '@env/environment';
import {
  IMPERSONATION_ORIGINAL_URL_COOKIE,
  IMPERSONATION_TOKEN_COOKIE,
  ImpersonationRepository,
  ImpersonationService
} from '@state/impersonation';
import { setWindowLocation } from '@helpers/url';

@Component({
  encapsulation: ViewEncapsulation.None,
  imports: [],
  selector: 'fl-impersonation-banner',
  styleUrls: ['./impersonation-banner.component.scss'],
  templateUrl: './impersonation-banner.component.html'
})
export class ImpersonationBannerComponent implements OnInit {
  private cookieService = inject(CookieService);
  private impersonationRepository = inject(ImpersonationRepository);
  private impersonationService = inject(ImpersonationService);

  session = toSignal(this.impersonationRepository.session$);
  active = computed(() => !!this.session()?.active);
  impersonatedUser = computed(() => this.session()?.impersonated_user);
  organization = computed(() => this.session()?.organization);

  ngOnInit(): void {
    if (!this.impersonationRepository.hasImpersonationCookie()) return;

    this.impersonationService.session$().subscribe({
      // a stale session is cleaned up by the impersonation interceptor
      error: () => this.impersonationRepository.setSession(null),
      next: (session) => this.impersonationRepository.setSession(session)
    });
  }

  exit(): void {
    this.impersonationService.exit$().subscribe({
      error: () => this.clearCookiesAndReturn(),
      next: () => this.clearCookiesAndReturn()
    });
  }

  private clearCookiesAndReturn(): void {
    let domain = new URL(environment.docsUrl).hostname;
    let originalUrl = this.cookieService.get(IMPERSONATION_ORIGINAL_URL_COOKIE);
    let organization = this.organization();
    let fallbackUrl = organization ? `${environment.fliUrl}/g/${organization.url_slug}` : environment.docsUrl;

    this.cookieService.delete(IMPERSONATION_TOKEN_COOKIE, '/', domain);
    this.cookieService.delete(IMPERSONATION_ORIGINAL_URL_COOKIE, '/', domain);

    setWindowLocation(originalUrl || fallbackUrl);
  }
}
